'use client';

import { useCreatePortalMutation } from '../api/billingApi';

/**
 * Opens the Stripe Customer Portal in the current window. Stripe handles
 * plan changes, payment methods, and cancellation — we don't reimplement
 * any of that.
 */
export function BillingPortalButton() {
  const [createPortal, { isLoading }] = useCreatePortalMutation();

  async function open() {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const { portal_url } = await createPortal({
      return_url: `${origin}/billing`,
    }).unwrap();
    window.location.assign(portal_url);
  }

  return (
    <button
      type="button"
      onClick={open}
      disabled={isLoading}
      className="rounded-md border border-border px-3 py-1.5 text-xs disabled:opacity-60"
    >
      {isLoading ? 'Opening…' : 'Manage subscription'}
    </button>
  );
}
